import { keepPreviousData, useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { http } from '@/lib/api';
import type { Paginated } from '@/lib/types';
import type { NotificationDto } from '@/lib/types-tracking';

export const notifKeys = {
  count: ['notifications', 'count'] as const,
  list: (page: number, unread: boolean, pageSize: number) => ['notifications', 'list', page, unread, pageSize] as const,
};

/** Contador de não lidas — consultado a cada 60 s. */
export const useUnreadCount = () =>
  useQuery({ queryKey: notifKeys.count, queryFn: () => http.get<{ count: number }>('/notifications/unread-count'), refetchInterval: 60_000 });

export const useNotifications = (page: number, unread: boolean, pageSize = 20, enabled = true) =>
  useQuery({
    queryKey: notifKeys.list(page, unread, pageSize),
    enabled,
    queryFn: () => http.get<Paginated<NotificationDto>>('/notifications', { page, pageSize, unread }),
    placeholderData: keepPreviousData,
  });

export function useMarkRead() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string | 'all') => (id === 'all' ? http.post('/notifications/read-all') : http.post(`/notifications/${id}/read`)),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['notifications'] }),
  });
}
